export const ROOT_HISTORY_STATE = 'history';

export const INITIAL_STATE = {
  list: []
};

//array of paths to keys need to be saved
export const HistoryWhiteListKeys = [[ROOT_HISTORY_STATE]];
